import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { BarChart } from '../Charts';
import { OnScrollWrapper } from '../UtilityWrappers';
import { isFieldValid } from '../../utils/validation';
import media from '../../utils/media';
import { RichH4, RichP1 } from '../Typography';
import { COLOR_MAPPING_INFOGRAPHIC } from '../../constants';
const GraphicContainer = styled.div `
  max-width: 480px;
  margin-bottom: 40px;
  width: 100%;
  ${media.mobile} {
    margin: 0px 15px 28px;
    width: calc(100% - 30px);
  }
`;
const ChartTitle = styled(RichH4) `
  margin: 15px 0px 5px;
  ${media.mobile} {
    margin: 25px 0px 5px;
  }
  color: ${COLOR_MAPPING_INFOGRAPHIC[0]};
`;
export const BarChartGraphic = ({ fields }) => {
    const [isComponentVisible, setIsComponentVisible] = useState(false);
    const [shouldInitiateAnimation, setShouldInitiateAnimation] = useState(false);
    useEffect(() => {
        if (isComponentVisible) {
            setTimeout(() => {
                setShouldInitiateAnimation(true);
            }, 1000);
        }
    }, [isComponentVisible]);
    if (!fields) {
        return null;
    }
    const { chartValue, graphicTitle, graphicBodyText } = fields;
    return (React.createElement(GraphicContainer, { className: "bar-chart-container" },
        React.createElement(OnScrollWrapper, { onVisibilityChange: setIsComponentVisible },
            React.createElement(React.Fragment, null,
                isFieldValid(chartValue) && (React.createElement(BarChart, { newValue: chartValue.value, initiateAnimation: shouldInitiateAnimation, color: COLOR_MAPPING_INFOGRAPHIC[0] })),
                graphicTitle && React.createElement(ChartTitle, { field: graphicTitle }),
                graphicBodyText && React.createElement(RichP1, { field: graphicBodyText })))));
};
